import { Flex, Text } from '@chakra-ui/react';

export type HelivanLabelVariant =
  | 'success'
  | 'error'
  | 'warning'
  | 'blue'
  | 'green'
  | 'blueDark'
  | 'default';

interface HelivanLabelProps {
  variant: HelivanLabelVariant;
  label: string;
  size?: 'sm' | 'lg';
}

export const HelivanLabel = ({ variant, label, size }: HelivanLabelProps) => {
  let textColor = '#21455E';
  let bgColor = '#EBF7FF';

  switch (variant) {
    case 'success': {
      textColor = '#245B4A';
      bgColor = '#DAFFF5';
      break;
    }
    case 'error': {
      textColor = '#770505';
      bgColor = '#FFE1E1';
      break;
    }
    case 'warning': {
      textColor = '#744210';
      bgColor = '#FEFCBF';
      break;
    }
    case 'blue': {
      textColor = '#21455E';
      bgColor = '#EBF7FF';
      break;
    }
    case 'green': {
      textColor = '#404E1D';
      bgColor = '#E3F9B9';
      break;
    }
    case 'blueDark': {
      bgColor = '#21455E';
      textColor = '#EBF7FF';
      break;
    }
    case 'default': {
      textColor = '#666666';
      bgColor = '#F0F0F0';
      break;
    }
  }

  return (
    <Flex
      bg={bgColor}
      px={size === 'lg' ? '12px' : '8px'}
      py={size === 'lg' ? '5px' : '2px'}
      justifyContent="center"
      alignItems="center"
      borderRadius="8px"
      width="fit-content"
    >
      <Text
        fontSize={size === 'lg' ? '14px' : '11px'}
        lineHeight="normal"
        fontWeight={500}
        color={textColor}
      >
        {label}
      </Text>
    </Flex>
  );
};
